/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["मध्यरात्रि","सुबह","दोपहर","शाम","रात"],u,u],[["आधी रात","सुबह","दोपहर","शाम","रात"],["मध्यरात्रि","सुबह","दोपहर","शाम","रात"],u],["00:00",["04:00","12:00"],["12:00","16:00"],["16:00","20:00"],["20:00","04:00"]]];
